<template>
    <div>
      <div>
        <label for="id" :class="{'sr-only': !label, 'mb-2': label}">{{ label }}</label>
        <div class="relative rounded-md shadow-sm">
          <input :id="id" v-bind="$attrs" :type="type" :value="value" :class="{ 'error': errors.length }" @input="$emit('input', $event.target.value)" @change="$emit('change', $event.target.value)" class="form-input block w-full text-xs sm:leading-5" />
        </div>
        <div v-if="!state && errors.length" class="form-error">{{ errors[0] }}</div>
      </div>
    </div>
</template>

<script>
  export default {
    name: 'FormInput',

    props: {
      id: {
        type: String,
        default() {
          return `text-input-${this._uid}`
        },
      },
      type: {
        type: String,
        default: 'text',
      },
      value: String|Number,
      label: String,
      errors: {
        type: Array,
        default: () => [],
      },
      state: Boolean,
    },
  }
</script>

<style scoped>

</style>
